import * as ReactBootstrap from "react-bootstrap";
import Moment from "react-moment";
import {PartRequestDeleteButton} from "./PartRequestDeleteButton";
import React from "react";
import {PartRequest, TicketPrint} from "../../../api";
import {BooleanConverter, ICONS} from "../../../components";

export type PartRequestLineProps={ ticket:TicketPrint,
    part_request:PartRequest
                                    onDelete?:(part_request:PartRequest)=>void,
                                    onQnARequest?:(part_request?:PartRequest)=>void,
                                    onUpdate?:(t?:TicketPrint)=>void,
                                }
export const PartRequestLine = ({   ticket,
                                    part_request,
                                    onDelete,
                                    onQnARequest,
                                    onUpdate,
                                }:PartRequestLineProps) => {
    return <ReactBootstrap.Card style={{marginBottom:"8px"}}>
        <ReactBootstrap.Card.Body>
    <ReactBootstrap.Row>
        <ReactBootstrap.Col className="p-0" xs="6">
            <strong>Description:</strong>
            {part_request.description}
            <sub>
                <Moment fromNow>{part_request.created_at}</Moment>
            </sub>
            <br/>
            <strong>Part Number:</strong> {part_request.part_number}
            <br/>
            <strong>Component Code:</strong> {part_request.component_code}
            <br/>
            <strong>Issue Code:</strong> {part_request.issue_code}
            <br/> <strong>Reproducibility:</strong>{' '}


            {part_request.reproducibility}
            <br/>
            <strong>Pricing Option:</strong> {part_request.pricing_option}
            <br/>
             <strong>Is Quote:</strong> <span style={{display: "inline-table"}}>{BooleanConverter(part_request.is_quote,"text-left text-start")}</span>
             <br/>
             <strong>Is Intangible Part:</strong> <span style={{display: "inline-table"}}>{BooleanConverter(part_request.is_intangible_part,"text-left text-start")}</span>

        </ReactBootstrap.Col>
        <ReactBootstrap.Col className="text-end p-0" xs="6">
            <ReactBootstrap.Button
                className={"me-1"}
                variant={'dark'}
                onClick={() => onQnARequest && onQnARequest(part_request)}
            >
                {ICONS.QUERY}
            </ReactBootstrap.Button>
            <PartRequestDeleteButton
                onDelete={(r) => {
                   onDelete &&  onDelete(r);
                   onUpdate({...ticket,part_requests:ticket.part_requests.filter(x=>x.url!=part_request.url)})
                }}
                record={part_request}
            />
        </ReactBootstrap.Col>
    </ReactBootstrap.Row></ReactBootstrap.Card.Body></ReactBootstrap.Card>
}
